// extracted by mini-css-extract-plugin
export var button = "socialMedia-module--button--99ea9";
export var cafeFormIntro = "socialMedia-module--cafe-form-intro--a1ec4";
export var highlight = "socialMedia-module--highlight--e76a3";
export var redButton = "socialMedia-module--red-button--3192e";
export var redTransparentButton = "socialMedia-module--red-transparent-button--0cbc4";
export var socialIcon = "socialMedia-module--social-icon--584e7";
export var spacedSocialIcon = "socialMedia-module--spaced-social-icon--ef8c0";
export var transparentButton = "socialMedia-module--transparent-button--bb043";
export var wrapper = "socialMedia-module--wrapper--657b7";